module.exports = __webpack_public_path__ + "static/media/file-jpg.08deec98.svg";